<template>
  <div class="big mydialog">
    <div class="page_title">剂型维护</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addDosageForm"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('422') : false
            "
          >添加剂型</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="drug_type_name"
              label="剂型"
            ></el-table-column>
            <el-table-column
              prop="drug_type_pid_str"
              label="剂型分类"
            ></el-table-column>
            <el-table-column label="歧黄医官APP">
              <template slot-scope="scope">
                <span v-if="scope.row.doctor_app == 1">开放</span>
                <span
                  v-if="scope.row.doctor_app == 2"
                  style="color: #d20e0e"
                >不开放</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="医生设置">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.doctor_type == 0"
                  type="text"
                  @click="
                    adddoctor = true;
                    isall_doctor = 1;
                    drug_type = scope.row.drug_type;
                  "
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('427')
                      : false
                  "
                >未设置</el-button>
                <span v-if="scope.row.doctor_type == 1">全部医生</span>
                <span v-if="scope.row.doctor_type == 2">部分({{ scope.row.doctor_count }}人)</span>
                <el-button
                  v-if="scope.row.doctor_type != 0"
                  type="text"
                  @click="
                    adddoctor = true;
                    isall_doctor = scope.row.doctor_type;
                    drug_type = scope.row.drug_type;
                  "
                  style="margin-left: 10px"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('427')
                      : false
                  "
                >修改</el-button>
              </template>
            </el-table-column> -->
            <el-table-column label="云诊所">
              <template slot-scope="scope">
                <span v-if="scope.row.clinic_web == 1">开放</span>
                <span
                  v-if="scope.row.clinic_web == 2"
                  style="color: #d20e0e"
                >不开放</span>
              </template>
            </el-table-column>
            <el-table-column label="诊所设置">
              <template slot-scope="scope">
                <span v-if="scope.row.clinic_count">{{ scope.row.clinic_count }}家</span>
                <el-button
                  v-else
                  type="text"
                  @click="setClinic(scope.row.drug_type)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('425')
                      : false
                  "
                >未设置</el-button>
                <el-button
                  v-if="scope.row.clinic_count"
                  type="text"
                  @click="setClinic(scope.row.drug_type)"
                  style="margin-left: 10px"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('425')
                      : false
                  "
                >修改</el-button>
              </template>
            </el-table-column>
            <el-table-column label="医生拍方购药">
              <template slot-scope="scope">
                <span v-if="scope.row.platform_phone == 1">开放</span>
                <span
                  v-if="scope.row.platform_phone == 2"
                  style="color: #d20e0e"
                >不开放</span>
              </template>
            </el-table-column>
            <el-table-column label="平台按方购药">
              <template slot-scope="scope">
                <span v-if="scope.row.platform_agree == 1">开放</span>
                <span
                  v-if="scope.row.platform_agree == 2"
                  style="color: #d20e0e"
                >不开放</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="addDosageForm(scope.row)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('423')
                      : false
                  "
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="请设置医生"
      :visible.sync="adddoctor"
      width="300px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 30px">
        <el-radio
          v-model="isall_doctor"
          :label="1"
        >全部医生</el-radio>
        <el-radio
          v-model="isall_doctor"
          :label="2"
        >部分医生</el-radio>
      </div>
      <div style="padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="setDoctor"
            size="medium"
          >确定</el-button>
          <el-button
            plain
            @click="adddoctor = false"
            size="medium"
          >取消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from '../../../api/system';
import _ from 'lodash';

export default {
  data() {
    return {
      adminList: [],
      tableData: [],
      adddoctor: false,
      addclinic: false,
      isall_doctor: 1,
      isall_clinic: 1,
      drug_type: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let page = 1;
      let pageNumber = 100000;
      this.axios
        .post('platform/Drugtype/getDrugTypeList', { page, pageNumber })
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
          }
        });
    },

    //添加剂型
    addDosageForm(row) {
      if (row.drug_type) {
        this.$router.push({
          path: 'adddosageform',
          query: {
            info: JSON.stringify(row)
          }
        });
      } else {
        this.$router.push('adddosageform');
      }
    },
    //设置医生
    setDoctor() {
      if (this.isall_doctor == 1) {
        let data = {
          type: 1,
          drug_type: this.drug_type
        };
        this.axios.post('platform/Drugtype/setDrugDoctor', data).then((res) => {
          if (res.code == 0) {
            this.$message.success('设置成功');
            this.adddoctor = false;
            this.getList();
          }
        });
      } else {
        this.$router.push({
          path: 'adddoctor',
          query: {
            drug_type: this.drug_type
          }
        });
      }
    },
    //设置诊所
    setClinic(drug_type) {
      this.$router.push({
        path: 'addclinic',
        query: {
          drug_type: drug_type
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
}

.rolenum {
  color: #669961;
  cursor: pointer;
}
.adminbox {
  text-align: left;
  min-height: 300px;
}
.admintitle {
  display: flex;
  background: #f5f5f5;
  padding: 0 20px;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  color: #262626;
  .name {
    width: 140px;
  }
  .desc {
    flex: 1;
    text-align: center;
    margin: 0 15px;
  }
  .statu {
    width: 100px;
  }
}
.adminitem {
  display: flex;
  padding: 0 20px;
  line-height: 48px;
  box-sizing: border-box;
  color: #262626;
  border-bottom: 1px solid #e8e9f0;
  .name {
    width: 140px;
  }
  .desc {
    flex: 1;
    text-align: center;
    margin: 0 15px;
  }
  .statu {
    width: 100px;
  }
}
</style>
<style lang="scss">
.mydialog .el-dialog__body {
  padding: 0px !important;
}
</style>